export const Nobel: string = '#b5b5b5';
export const Grey: string = '#2D2D2D';
export const GreyLight: string = '#E0E0E0';
export const DarkBlue: string = '#000066';
export const White: string = '#ffffff';
export const WhiteLilac: string = '#fafbfd';
export const Black: string = '#000';
export const Red: string = '#ff0000';
